import React from 'react';
import useGlobal from '../../../store';
import { Button } from 'reactstrap';
import { deleteCookie } from '../../../services/utils';

function Topbar(props) {

	const [ui] = useGlobal(
		state => state.ui
	);

	const showChat = (e) => {
		window.$chatwoot.toggle();
		e.stopPropagation();
		/*
		window.HappyFoxChat.showWidget(() => {
			console.log('show chat callback');
		});
		window.HappyFoxChat.expandChatbox(() => {
			console.log('show chat callback');
		});
		*/
	}

	const logout = () => {
		console.log('logout');
		deleteCookie('cla_token', 'christmaslistapp.com');
		deleteCookie('cla_uid', 'christmaslistapp.com');
		window.location = "https://www.christmaslistapp.com/sign-in";
	}
	
  	return (ui.menu.showMobileSubmenu ?
		<div className="kt-header__topbar">
			<div className="kt-visible-tablet-and-mobile-flex kt-header__topbar-item kt-header__topbar-item--search">
				<div className="kt-header__topbar-wrapper">
					<div className="flex-apart">
						<Button onClick={(e)=> showChat(e)} className="btn-wide btn-link mr-1">
							<i className="flaticon-chat"></i> Chat with Support
						</Button>
						<Button onClick={()=> logout()} className="btn-wide btn-link">
							<i className="flaticon-logout"></i> Logout
						</Button>
					</div>
				</div>
			</div>
			
		</div> : <></>);
}

export default Topbar;